export const DEFAULT_KNOWLEDGE_INSTANCE_ID = "library";
/** Build the Library home route with an encoded instance identifier. */
export function knowledgeHomePath(instanceId) {
    return `/app/knowledge-studio/${encodeURIComponent(instanceId)}`;
}
/** Build the canonical route for a typed knowledge domain. */
export function knowledgeDomainPath(instanceId, domainId) {
    return `${knowledgeHomePath(instanceId)}/${domainId}`;
}
/** Build a guide route from its canonical domain and editorial slug. */
export function knowledgeArticlePath(instanceId, domainId, slug) {
    return `${knowledgeDomainPath(instanceId, domainId)}/${slug}`;
}
//# sourceMappingURL=routes.js.map